import { fetchPost } from '../Service/ApiService'
import { authmodel } from '../Provider/AuthProvider';

export const activeOnlineCourse = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`onlinecourse/bulckapprove`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};

export const deleteApplicants = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`onlinecourse/bulckdelete`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};






